import { getPercentAPI } from '../services/certificate'

async function updateProfilePercent(dispatch) {

  const res = await getPercentAPI()
  if (!res) return
  if (res.status) {
    dispatch({ type: 'SET_PERCENT', payload: res.result1.percentAll ?? '' })
  }
}

export default updateProfilePercent
